<template>
  <component :is="compId" :params="params"></component>
</template>
<script>
import systemSet_org_depUser from './deptUser';
  import systemSet_org_InvalidUser from './InvalidUser';
export default {
  components:{
    systemSet_org_depUser,
    systemSet_org_InvalidUser
  },
  data() {
    return {
      compId:""
    }
  },
  props:{
    viewId:String,
    params:Object,
    default:"systemSet_org_depUser"
  },
  mounted() {
    var me = this;
    if(this.viewId){
      this.compId = this.viewId;
    }else{
      this.compId = "systemSet_org_depUser";
    }
  },
  methods: {
    changeView(viewId) {
      this.compId = viewId;
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/org/user.vue